import React from 'react';
import { ClientsTerms, H2, LayoutSingleColumn, Page, PrimaryButton } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { useIntl } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';

import css from './TermsAndConditionsClientPage.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const TermsAndConditionsClientPageComponent = props => {
  const { scrollingDisabled } = props;

  const intl = useIntl();
  const title = intl.formatMessage({ id: 'TermsAndConditionsClientPage.title' });

  const history = useHistory();

  return (
    <Page
      title={title}
      scrollingDisabled={scrollingDisabled}
      openGraphType="website"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: title,
      }}
    >
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer currentPage="HowItWorksPage" />
          </>
        }
        footer={<FooterContainer />}
      >
        <div className={css.root}>
          <H2 as="h1">{title}</H2>
          <ClientsTerms className={css.content} />
          <PrimaryButton type="button" onClick={() => history.goBack()}>
            {intl.formatMessage({ id: 'General.goBack' })}
          </PrimaryButton>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const TermsAndConditionsClientPage = compose(
  withRouter,
  connect(mapStateToProps)
)(TermsAndConditionsClientPageComponent);

export default TermsAndConditionsClientPage;
